import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../stores/store';
import Button from '../../../common/button/button.component';
import { printBlob } from '../../../utils/generic/generic.utils';
import { Shipment } from '../../../models/parcelDeliveryMiles';

interface Props {
  shipmentId: number;
  isRow?: boolean;
}

const PrintLabelButton = ({ shipmentId, isRow = false }: Props) => {
  const {
    parcelListStore: {
      shipment: storedShipment,
      isPrintingLabel,
      printLabel,
      getParcel,
      togglePrintingLabel,
    },
    commonStore: { toastError },
  } = useStore();
  const { t } = useTranslation();

  const handlePrintLabel = async () => {
    try {
      togglePrintingLabel(shipmentId);
      let shipment: Shipment | undefined;
      if (storedShipment?.id === shipmentId) {
        shipment = storedShipment;
      } else {
        shipment = await getParcel(shipmentId);
      }
      const blob = await printLabel(shipmentId);
      await printBlob(
        blob,
        shipment!.file_names?.label ||
          `${shipment!.tracking_numbers.first_mile[0]}.pdf`
      );
    } catch (error: any) {
      toastError(t(error.message));
    } finally {
      togglePrintingLabel(shipmentId);
    }
  };

  return (
    <Button
      contentStyle={isRow ? 'thin' : 'normal'}
      size={isRow ? 'mini' : 'medium'}
      isLoading={isPrintingLabel(shipmentId)}
      onMouseUp={(event) => {
        event.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
        handlePrintLabel();
      }}>
      {t('print_label')}
    </Button>
  );
};

export default observer(PrintLabelButton);
